import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Button, Modal } from 'react-bootstrap'
import { closeIdentityPdfModalDialog } from '../../../actions/pdf_modal_dialog'

import { pdfjs, Page, Document } from 'react-pdf'
// this is workaround https://github.com/wojtekmaj/react-pdf/wiki/Known-issues
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

class PdfModalDialog extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      numPages: null,
      pageNumber: 1,
    }
  }

  onDocumentLoad = ({ numPages }) => {
    this.setState({ numPages })
  }

  render() {
    const { isModalDialogOpen, documentData, closeIdentityPdfModalDialog } = this.props
    const { pageNumber, numPages } = this.state
    if (!documentData) {
      return null
    }
    return (
      <Modal size={'lg'} show={isModalDialogOpen} onHide={() => closeIdentityPdfModalDialog()}>
        <Modal.Header closeButton>
          <Modal.Title>Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Document file={documentData.document} onLoadSuccess={this.onDocumentLoad}>
            {Array.from(new Array(numPages), (el, index) => (
              <Page width={800} key={`page_${index + 1}`} pageNumber={index + 1} />
            ))}
          </Document>
          <div>
            {numPages && (
              <p>
                Page {pageNumber} of {numPages}
              </p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='default' onClick={() => closeIdentityPdfModalDialog()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  isModalDialogOpen: state.identityPdfModalDialog.isModalDialogOpen,
  documentData: state.identityPdfModalDialog.content,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeIdentityPdfModalDialog,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PdfModalDialog))
